<template>
    <templateList :pageType="1"/>
</template>

<script>
    import templateList from './index'
    let timer = null
    export default {
        name: 'myChoice',
        components: {
            templateList,
        },
    }
</script>
